import { render, staticRenderFns } from "./Conta.vue?vue&type=template&id=5ff0de4a&scoped=true"
import script from "./Conta.vue?vue&type=script&lang=js"
export * from "./Conta.vue?vue&type=script&lang=js"
import style1 from "./Conta.vue?vue&type=style&index=1&id=5ff0de4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0de4a",
  null
  
)

export default component.exports